// src/modules/app-views/_apps/appsindico/parkingSpots/pages/Init/components/tableColumns/statusColumn.jsx
import { Tag } from 'antd';
import translateX from 'utils/translateX';

const STATUS_COLORS = {
  available: 'green',
  occupied: 'red',
  rented: 'purple',
  sold: 'orange',
};

function statusColumn(buildColumnProps, options = {}) {
  const {
    key = 'status',
    title = 'status',
    dataIndex = 'status',
    width = 120,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: text => {
      const color = STATUS_COLORS[text] || 'default';
      return <Tag color={color}>{translateX(text || 'unknown')}</Tag>;
    },
  };
}

export default statusColumn;
